// extracted by mini-css-extract-plugin
export default {"header__text":"expenses_header_header__text__MKTgz","description__text":"expenses_header_description__text__Us6av"};